export enum UserRole {
  SuperAdmin = 'ssg-ciam-adminapp-superadmin',
  Legal = 'ssg-ciam-adminapp-legal',
  Iopex = 'ssg-ciam-adminapp-iopex',
  CSI = 'ssg-ciam-adminapp-csi',
  ServiceDesk = 'ssg-ciam-adminapp-servicedesk',
  PartnerOps = 'ssg-ciam-adminapp-partnerops'
}

export enum AppFunction {
  OktaProfile = 'Okta Profile',
  DeleteOktaProfile = 'Delete Okta Profile',
  FindUserInDPL = 'Find User in DPL Table',
  ClearUserFromDPL = 'Clear User from DPL Table',
  PasswordReset = 'Password Reset',
  SetTemporaryPassword = 'Set Temporary Password',
  ActivationEmail = 'Activation Email',
  GenerateLink = 'Generate Link',
  AttributeManagement = 'Attribute Management',
  PIIReport = 'PII Report'
}

export const functionRoleMap: Record<AppFunction, UserRole[]> = {
  [AppFunction.OktaProfile]: [
    UserRole.SuperAdmin,
    UserRole.CSI,
    UserRole.ServiceDesk,
    UserRole.Legal,
    UserRole.Iopex,
    UserRole.PartnerOps
  ],
  [AppFunction.DeleteOktaProfile]: [
    UserRole.SuperAdmin,
    UserRole.CSI,
    UserRole.ServiceDesk,
    UserRole.Iopex
  ],
  [AppFunction.FindUserInDPL]: [
    UserRole.SuperAdmin,
    UserRole.CSI,
    UserRole.ServiceDesk,
    UserRole.Legal,
    UserRole.Iopex
  ],
  [AppFunction.ClearUserFromDPL]: [
    UserRole.SuperAdmin,
    UserRole.Legal,
    UserRole.Iopex
  ],
  [AppFunction.PasswordReset]: [UserRole.SuperAdmin],
  [AppFunction.SetTemporaryPassword]: [UserRole.SuperAdmin],
  [AppFunction.ActivationEmail]: [UserRole.SuperAdmin],
  [AppFunction.GenerateLink]: [UserRole.SuperAdmin],
  [AppFunction.AttributeManagement]: [UserRole.SuperAdmin],
  [AppFunction.PIIReport]: [
    UserRole.SuperAdmin,
    UserRole.CSI,
    UserRole.ServiceDesk
  ]
}
